module.exports = __webpack_public_path__ + "12-o1.gif?0929e7f221e9370fbe1593177117f5ab";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quiz/questions/12-o1.gif
// module id = 622
// module chunks = 0